import Vue from "vue";
import Router from "vue-router";
import notFound from "@/components/notFound";
import onlineshow from "@/view/onlineshow";
import business from "@/view/business";
import article from "@/view/article";
import side1 from "@/view/page2/side1";
import side2 from "@/view/page2/side2";
import login from "@/view/login";
import register from "@/view/register";
import viewsmore from "@/view/viewsmore";
import companyIntroduction from "@/view/companyIntroduction";
import productlist from "@/view/productlist";
import hotlist from "@/view/hotlist";
import commedia from "@/view/commedia";
import exhibitors from "../view/exhibitors/index.vue";
import document from "../view/document/_id.vue";
import { EventBus } from "@/EventBus.js";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      component: () =>
        import(/* webpackChunkName: "index" */ "../view/index.vue")
    },
    {
      path: "/article/:id",
      name: "article",
      component: () =>
        import(/* webpackChunkName: "article" */ "../view/article/_id.vue")
    },
    {
      path: "/document/:id",
      name: "document",
      component: document
    },
    {
      path: "/exhibitors",
      name: "exhibitors",
      component: exhibitors
    },
    {
      path: "/exhibit/:id",
      name: "exhibit",
      component: () =>
        import(/* webpackChunkName: "exhibit" */ "../view/exhibit/_id.vue")
    },
    {
      path: "/onlineshow",
      name: "onlineshow",
      component: onlineshow
    },
    {
      path: "/business",
      name: "business",
      component: business
    },
    {
      path: "/article",
      name: "articles",
      component: article
    },
    {
      path: "/side1",
      name: "side1",
      component: side1
    },
    {
      path: "/side2",
      name: "side2",
      component: side2
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: {
        plainLayout: true
      }
    },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: {
        plainLayout: true
      }
    },
    {
      path: "*",
      name: "notFound",
      component: notFound
    },
    {
      path: "/viewsmore",
      name: "viewsmore",
      component: viewsmore
    },
    {
      path: "/companyIntroduction",
      name: "companyIntroduction",
      component: companyIntroduction
    },

    {
      path: "/productlist",
      name: "productlist",
      component: productlist
    },
    {
      path: "/hotlist",
      name: "hotlist",
      component: hotlist
    },
    {
      path: "/commedia",
      name: "commedia",
      component: commedia
    },
    {
      path: "/meetings",
      name: "MeetingList",
      component: () =>
        import(/* webpackChunkName: "MeetingList" */ "../view/meeting/list.vue")
    },
    {
      path: "/recent-meetings",
      name: "RecentMeetings",
      component: () =>
        import(
          /* webpackChunkName: "RecentMeeting" */ "../view/meeting/recent-meetings.vue"
        )
    },
    {
      path: "/meeting/:id",
      name: "MeetingDetail",
      component: () =>
        import(
          /* webpackChunkName: "MeetingDetail" */ "../view/meeting/detail.vue"
        )
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

//路由拦截
// let noLogin = ['/login']
// router.beforeEach((to, from, next) => {
// 	if (noLogin.indexOf(to.path) <= -1 && !localStorage.getItem('token')) {
// 		console.log(noLogin.indexOf(to.path))
//     localStorage.clear()
// 		next({
// 			path: '/login' // 跳转到登录页
// 		})
// 	} else next()
// })

router.beforeEach((to, from, next) => {
  console.log(from, to.query);
  if (to.path === "/login") {
    console.log(from);
    debugger;
    if (to.query.redirect) {
      next();
    } else {
      next({
        path: to.path,
        query: {
          ...to.query,
          redirect: from.fullPath,
          lang: localStorage.getItem("lang")
        }
      });
    }
  } else {
    let tabindex = -1;
    switch (to.path) {
      case "/home":
        tabindex = 0;
        break;
      case "/onlineshow":
        tabindex = 1;
        break;
      case "/business":
        tabindex = 2;
        break;
      case "/meetings":
        tabindex = 3;
        break;
      case "/article":
        tabindex = 4;
        break;
      case "/document/5":
        tabindex = 5;
        break;
      case "exhibitors":
        tabindex = 6;
        break;

      default:
        tabindex = -1;
        break;
    }
    EventBus.$emit("switchTab", tabindex);
    if (!to.query || (to.query && !to.query.lang)) {
      next({
        path: to.path,
        query: {
          ...to.query,
          lang: localStorage.getItem("language") || "zh"
        }
      });
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js